import type { SourceReadModelId } from './read-model';

export const SLICE05_CONNECTION_EVENT_NAME = 'ownyou:slice05-connection-marker';

export interface Slice05ConnectionMarker {
  type: 'slice05_connection_marker';
  version: 1;
  timestamp: number;
  kind: 'reauth_branch' | 'reauth_result' | 'source_detail_render' | 'connections_render';
  status: 'success' | 'blocked' | 'error' | 'skipped';
  sourceId?: SourceReadModelId;
  branch?: 'google' | 'microsoft' | 'tauri' | 'plaid' | 'browser-extension' | 'location' | 'unsupported';
  reasonCode: string;
}

export function recordSlice05ConnectionMarker(input: Omit<Slice05ConnectionMarker, 'type' | 'version' | 'timestamp'> & {
  timestamp?: number;
}): Slice05ConnectionMarker {
  const marker: Slice05ConnectionMarker = {
    type: 'slice05_connection_marker',
    version: 1,
    timestamp: input.timestamp ?? Date.now(),
    kind: input.kind,
    status: input.status,
    sourceId: input.sourceId,
    branch: input.branch,
    reasonCode: sanitizeToken(input.reasonCode),
  };

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(SLICE05_CONNECTION_EVENT_NAME, { detail: marker }));
  }
  console.info('[Slice05] Connection marker', marker);

  return marker;
}

function sanitizeToken(value: string): string {
  return value.replace(/[^a-zA-Z0-9_.:-]/g, '_').slice(0, 80);
}
